export default __webpack_public_path__ + "static/media/screenfive.288f2be6.jpg";